import type { CellSegment } from '../schemas'

export type TagCellItem = { kind: 'tag' | 'reference'; value: string }

export function tagItems(content: CellSegment[]): TagCellItem[] {
  return content.flatMap((segment) => [
    ...(segment.text ? [{ kind: 'tag' as const, value: segment.text }] : []),
    ...segment.reference_ids.map((value) => ({ kind: 'reference' as const, value })),
  ])
}

export function tagContent(items: TagCellItem[]): CellSegment[] {
  const content: CellSegment[] = []
  for (const item of items) {
    if (item.kind === 'tag') content.push({ text: item.value, reference_ids: [] })
    else {
      let segment = content[content.length - 1]
      // Keep repeated occurrences even when the intervening tag was removed.
      if (!segment || segment.reference_ids.includes(item.value)) {
        segment = { text: '', reference_ids: [] }
        content.push(segment)
      }
      segment.reference_ids.push(item.value)
    }
  }
  return content
}
